import React from "react";
import Icon from "../icon/Icon";
import { Pagination, PaginationLink, PaginationItem } from "reactstrap";

const PaginationComponent = ({ itemPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemPerPage); i++) {
    pageNumbers.push(i);
  }

  const nextPage = () => {
    paginate(currentPage + 1);
  };

  const prevPage = () => {
    paginate(currentPage - 1);
  };

  return (
    <Pagination aria-label="Page navigation example">
      <PaginationItem disabled={currentPage - 1 === 0 ? true : false}>
        <PaginationLink
          className="page-link-prev"
          onClick={(ev) => {
            ev.preventDefault();
            prevPage();
          }}
          href="#prev"
        >
          <Icon name="chevrons-left" />
          <span>Prev</span>
        </PaginationLink>
      </PaginationItem>

      {
        (pageNumbers?.length<8) ? (
          pageNumbers?.map((item) => {
            return (
              <PaginationItem className={currentPage === item ? "active" : ""} key={item}>
                <PaginationLink
                  tag="a"
                  href="#pageitem"
                  onClick={(ev) => {
                    ev.preventDefault();
                    paginate(item);
                  }}
                >
                  {item}
                </PaginationLink>
              </PaginationItem>
            );
          })
        ) : (pageNumbers?.length>=8&&currentPage<5) ? (
          <>
            {
              pageNumbers?.slice(0,5)?.map((item) => {
                return (
                  <PaginationItem className={currentPage === item ? "active" : ""} key={item}>
                    <PaginationLink
                      tag="a"
                      href="#pageitem"
                      onClick={(ev) => {
                        ev.preventDefault();
                        paginate(item);
                      }}
                    >
                      {item}
                    </PaginationLink>
                  </PaginationItem>
                );
              })
            }
            <PaginationItem>
              <PaginationLink>
                ...
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                tag="a"
                href="#pageitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  paginate(pageNumbers[pageNumbers.length-1]);
                }}
              >
                {pageNumbers[pageNumbers.length-1]}
              </PaginationLink>
            </PaginationItem>
          </>
        ): (pageNumbers?.length>=8&&currentPage>4 && currentPage < pageNumbers.length-3) ? (
          <>
            <PaginationItem>
              <PaginationLink
                tag="a"
                href="#pageitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  paginate(1);
                }}
              >
                {1}
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink>
                ...
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                tag="a"
                href="#pageitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  paginate(currentPage-1);
                }}
              >
                {currentPage-1}
              </PaginationLink>
            </PaginationItem>
            <PaginationItem className="active">
              <PaginationLink
                tag="a"
                href="#pageitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  paginate(currentPage);
                }}
              >
                {currentPage}
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                tag="a"
                href="#pageitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  paginate(currentPage+1);
                }}
              >
                {currentPage+1}
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink>
                ...
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink
                tag="a"
                href="#pageitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  paginate(pageNumbers[pageNumbers.length-1]);
                }}
              >
                {pageNumbers[pageNumbers.length-1]}
              </PaginationLink>
            </PaginationItem>
          </>
        ) : (pageNumbers?.length>=8&&currentPage>4 && currentPage >= pageNumbers.length-3) ? (
          <>
            <PaginationItem>
              <PaginationLink
                tag="a"
                href="#pageitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  paginate(1);
                }}
              >
                {1}
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink>
                ...
              </PaginationLink>
            </PaginationItem>
            {
              pageNumbers.slice(-5)?.map((item) => {
                return (
                  <PaginationItem className={currentPage === item ? "active" : ""} key={item}>
                    <PaginationLink
                      tag="a"
                      href="#pageitem"
                      onClick={(ev) => {
                        ev.preventDefault();
                        paginate(item);
                      }}
                    >
                      {item}
                    </PaginationLink>
                  </PaginationItem>
                );
              })
            }
          </>
        ) : null
      }

      <PaginationItem disabled={pageNumbers[pageNumbers.length - 1] === currentPage}>
        <PaginationLink
          className="page-link-next"
          onClick={(ev) => {
            ev.preventDefault();
            nextPage();
          }}
          href="#next"
        >
          <span>Next</span>
          <Icon name="chevrons-right" />
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  );
};
export default PaginationComponent;
